export default __webpack_public_path__ + "static/media/320.8f1b41ba.gif";